import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../../shared/Navbar/Navbar";
import Footer from "../../../shared/Footer/Footer";
import ArticleDetailBanner from "./ArticleDetailBanner/ArticleDetailBanner";
import Details from "./Details/Details";
import LatestBlog from "./LatestBlog/LatestBlog";
import HaveAProject from "../HaveAProject/HaveAProject";
import { useInsightsSection } from "../../../../context/InsightsPageContext";
import { getArticlesFromSection } from "../../../../services/contentApi";

const ArticleDetail = () => {
  const { slug } = useParams();
  const { section, loading } = useInsightsSection("articles");

  const articles = useMemo(
    () => (section?.fields ? getArticlesFromSection(section) : []),
    [section]
  );

  const article = useMemo(
    () => articles.find((item) => item.slug === slug) ?? null,
    [articles, slug]
  );

  if (loading || !section?.fields) return null;
  if (!article) return null;

  return (
    <div>
      <Navbar />
      <ArticleDetailBanner article={article} />
      <Details article={article} />
      <LatestBlog articles={articles} currentSlug={slug} />
      <HaveAProject />
      <Footer />
    </div>
  );
};

export default ArticleDetail;
